import i18next from "i18next";

export const formatCurrency = (value: number, currency = "EUR") => {
  return new Intl.NumberFormat(i18next.language, {
    style: "currency",
    currency,
  }).format(value);
};
